/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const TaskList = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M5.00006 7.06072L8.53039 3.53039L7.46973 2.46973L5.00006 4.9394L3.53039 3.46973L2.46973 4.53039L5.00006 7.06072Z"
                        fill={color}
                    />
                    <path d="M22 4.50006H10V6.00006H22V4.50006Z" fill={color} />
                    <path d="M22 11.5001H10V13.0001H22V11.5001Z" fill={color} />
                    <path d="M10 18.5001H22V20.0001H10V18.5001Z" fill={color} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.5 14.5001C6.88071 14.5001 8 13.3808 8 12.0001C8 10.6193 6.88071 9.50006 5.5 9.50006C4.11929 9.50006 3 10.6193 3 12.0001C3 13.3808 4.11929 14.5001 5.5 14.5001ZM5.5 13.0001C6.05228 13.0001 6.5 12.5523 6.5 12.0001C6.5 11.4478 6.05228 11.0001 5.5 11.0001C4.94772 11.0001 4.5 11.4478 4.5 12.0001C4.5 12.5523 4.94772 13.0001 5.5 13.0001Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 19.0001C8 20.3808 6.88071 21.5001 5.5 21.5001C4.11929 21.5001 3 20.3808 3 19.0001C3 17.6193 4.11929 16.5001 5.5 16.5001C6.88071 16.5001 8 17.6193 8 19.0001ZM6.5 19.0001C6.5 19.5523 6.05228 20.0001 5.5 20.0001C4.94772 20.0001 4.5 19.5523 4.5 19.0001C4.5 18.4478 4.94772 18.0001 5.5 18.0001C6.05228 18.0001 6.5 18.4478 6.5 19.0001Z"
                        fill={color}
                    />
                </svg>
        );
    };
